import React from "react";
import Fade from "react-reveal/Fade";

import Countdown from "react-countdown-now";

import "./RecallInteraction.css";

import ProcessString from "react-process-string";

import { createItemJson, currentLessonAttempt, currentLesson } from "../../common/services";

// toast component
import { toast, ToastContainer } from "react-toastify";

import { dateToString } from "../../common/utils";

interface Istate {
  completiontext: any;
  oncomplete: any;
  demomode: boolean;
  interactionid: any;
  introtext: any;
  lessonid: any;
  penalty: number;
  question: any;
  redwords: any;
  show: boolean;
  submittext: any;
  timelimit: number;
}

class RecallInteraction extends React.Component<Istate> {
  public state = {
    answer: true,
    completed: false,
    completiontext: this.props.completiontext,
    demomode: this.props.demomode,
    interactions: 0,
    introtext: this.props.introtext,
    launched: false,
    penalty: this.props.penalty,
    question: this.props.question,
    quiz: false,
    quizlaunchtime: Date.now() + 5000,
    redWords: this.props.redwords.split(","),
    score: 0,
    show: false,
    showTimer: false,
    timelimit: this.props.timelimit * 1000,
  };

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.process = this.process.bind(this);
    this.onFocus = this.onFocus.bind(this);
  }

  public handleClick() {
    this.setState({ show: !this.state.show });
  }

  public onFocus() {
    const newinteractions = this.state.interactions + 1;
    this.setState({ interactions: newinteractions });
    console.log(newinteractions);
  }

  public handleGenCreatedItemLoaded(res) {
    console.log(res);
    if (res.code === 200 || res.code === 201) {
      this.setState({ completed: true });
      // toast.info(this.props.completiontext);

      setTimeout(this.props.oncomplete(), 1500);
    } else {
      toast.error("Please try again");
    }
  }

  public process(e) {
    e.preventDefault();

    const item = {
      time_start: dateToString(this.state.quizlaunchtime),
      time_end: dateToString(Date.now()),
      tries_count: this.state.interactions,
      interaction: this.props.interactionid,
      lesson: this.props.lessonid,
      answer: [] as any[],
    };

    const ky = "value";
    const ansCount = this.state.redWords.length;

    const tempans = [] as any[];

    for (let i = 1; i <= ansCount; i++) {
      const anskey = "ans" + i;
      const ansObject = this.refs[anskey];

      tempans.push({
        word: ansObject[ky],
        index: this.state.question.indexOf(this.state.redWords[i - 1]),
      });
    }

    item.answer = tempans;

    if (!this.props.demomode) {
      const currentlesson = currentLesson();
      createItemJson(
        "interaction_attempts/?attemptid=" + currentlesson.sessionKey,
        item,
        (text) => this.handleGenCreatedItemLoaded(text)
      );
    } else {
      // toast.info(this.props.completiontext);
      // toast.info("demo mode, interaction complete");
      setTimeout(this.props.oncomplete(), 2500);
    }

    console.log(item);
  }

  public recallText() {
    const prepattern = this.props.redwords.replace(/,/g, "|");

    console.log(prepattern);

    const config = [
      {
        fn: (key, result) => (
          <input
            required={true}
            onFocus={this.onFocus}
            className="recall-answer-input"
            key={key}
            id={key}
            ref={"ans" + key}
            autoComplete="off"
          />
        ),
        regex: new RegExp(prepattern, "g"),
      },
    ];

    const stringWithRecall = this.state.question;
    const processed = ProcessString(config)(stringWithRecall);
    return processed;
  }

  public render() {
    return (
      <div className="recall-component-container" style={{ color: "white" }}>
        <div className="recall-content">
          <div className="recall-exercise-details">
            <form onSubmit={this.process}>
              <Fade when={!this.state.launched}>
                <p
                  className="recall-intro-text"
                  style={{ display: this.state.launched ? "none" : "block" }}
                >
                  {this.props.introtext}
                </p>
              </Fade>

              <Fade when={this.state.quiz}>
                <p
                  className="recall-question"
                  style={{ display: !this.state.quiz ? "none" : "block" }}
                >
                  {this.state.question}
                </p>
              </Fade>

              <Fade when={this.state.answer === false && !this.state.completed}>
                <p className="recall-question">{this.recallText()}</p>
              </Fade>

              <Fade when={this.state.completed && this.state.demomode}>
                <div>
                  <p id="exercise-complete">{this.state.completiontext}</p>
                </div>
              </Fade>

              <div className="submit-button-cont">
                <Fade
                  when={this.state.answer === false && !this.state.completed}
                >
                  <button
                    type="submit"
                    className="blue-button submit-interaction"
                    style={{
                      display:
                        this.state.answer === false && !this.state.completed
                          ? "block"
                          : "none",
                    }}
                  >
                    {this.props.submittext}
                  </button>
                </Fade>
              </div>
            </form>
          </div>

          <div className="recall-duration-details">
            <Fade
              className="duration-container"
              when={this.state.show === false}
              collapse={true}
            >
              <p className="right">
                Your quiz begins in:
                <Countdown
                  date={this.state.quizlaunchtime}
                  // tslint:disable-next-line jsx-no-lambda
                  onComplete={() => {
                    this.setState({
                      show: true,
                      quiz: true,
                      showTimer: true,
                      launched: true,
                    });
                  }}
                />
              </p>
            </Fade>

            <Fade
              when={this.state.showTimer}
              collapse={true}
              style={{ display: !this.state.showTimer ? "flex" : "none" }}
            >
              <p className="right duration-countdown">
                Text will disappear in:{" "}
                <Countdown
                  date={this.state.quizlaunchtime + this.state.timelimit}
                  // tslint:disable-next-line jsx-no-lambda
                  onComplete={() => {
                    this.setState({
                      quiz: false,
                      answer: false,
                      showTimer: false,
                    });
                  }}
                />
              </p>
            </Fade>
          </div>
        </div>
      </div>
    );
  }
}
export default RecallInteraction;



// WEBPACK FOOTER //
// ./src/components/RecallInteraction/RecallInteraction.Component.tsx